import React from 'react';
import { motion } from 'framer-motion';
import { FiPhoneIncoming, FiHeadphones, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const CallTypes = () => {
  return (
    <section id="call-types" className="py-24 bg-slate-950 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-[500px] bg-blue-900/10 blur-[120px] rounded-full pointer-events-none"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-blue-500 font-bold tracking-wide uppercase text-sm mb-2">Delivery Methods</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">How VideoNation Delivers</h3>
          <p className="text-slate-400 text-lg">
            Whether you prefer direct calls straight from our ads or pre-qualified warm transfers.
          </p>
        </div>
        <div className="grid lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700/50 p-10 rounded-3xl relative overflow-hidden group"
          >
            <div className="w-16 h-16 bg-blue-600/20 rounded-2xl flex items-center justify-center mb-8 border border-blue-500/30">
              <SafeIcon icon={FiPhoneIncoming} className="text-3xl text-blue-400" />
            </div>
            <h4 className="text-3xl font-bold text-white mb-4">Inbound Calls</h4>
            <p className="text-slate-400 mb-8 leading-relaxed">
              Consumers dial a toll-free number directly from our targeted ads.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700/50 p-10 rounded-3xl relative overflow-hidden group"
          >
            <div className="w-16 h-16 bg-purple-600/20 rounded-2xl flex items-center justify-center mb-8 border border-purple-500/30">
              <SafeIcon icon={FiHeadphones} className="text-3xl text-purple-400" />
            </div>
            <h4 className="text-3xl font-bold text-white mb-4">Warm Transfers</h4>
            <p className="text-slate-400 mb-8 leading-relaxed">
              Leads are pre-screened before being warm-transferred to your team.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CallTypes;